import { Button, Group, Stack, Text } from '@mantine/core';

import { useBulkArchiveBatches } from '@hooks/batch';

export interface BulkArchiveBatchesModalProps {
  onClose: () => void;
  onBulkActionDone?: () => void;
  selectedBatchIds: string[];
}

export const BulkArchiveBatchesModal: React.FC<BulkArchiveBatchesModalProps> = ({ onClose, onBulkActionDone, selectedBatchIds }) => {
  const bulkArchiveBatchesMutation = useBulkArchiveBatches();

  const handleArchive = () => {
    bulkArchiveBatchesMutation.mutate(
      { batchIds: selectedBatchIds },
      {
        onSuccess: () => {
          onBulkActionDone?.();
          onClose();
        },
      },
    );
  };

  return (
    <Stack>
      <Text>
        Are you sure you want to archive {selectedBatchIds.length} batch{selectedBatchIds.length === 1 ? '' : 'es'}?
      </Text>
      <Group justify="center">
        <Button type="button" variant="transparent" onClick={onClose} size="lg">
          Cancel
        </Button>
        <Button type="submit" variant="filled" size="lg" onClick={handleArchive} loading={bulkArchiveBatchesMutation.isPending}>
          Archive batches
        </Button>
      </Group>
    </Stack>
  );
};
